export function setWrapperDefaultParams(wrapperId) {
    let previousWrapperState = window.growtype_post['wrappers'][wrapperId] || {};

    if (previousWrapperState['infinite_load_observer']) {
        previousWrapperState['infinite_load_observer'].disconnect();
    }

    window.growtype_post['wrappers'][wrapperId] = {
        terms_filter: [],
        filter_url_params_prefix: wrapperId + '-s_'
    };
}
